import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-work-with-us',
  templateUrl: './work-with-us.component.html',
  styleUrls: ['./work-with-us.component.scss']
})
export class WorkWithUsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('채용 | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: '최첨단 기술을 넘어 도전을 거부하지 않는 열정적인 20인으로 구성된 팀입니다. 도전에 주저하지 않는다면, 지원하십시오!' });
    this.metaTagService.updateTag({ name: 'keywords', content: '학술 및 기술 글쓰기 문법 검사기, 고급 문법 교정, 학술적 글쓰기 지원, 기술적 글쓰기 지원' });
    this.metaTagService.updateTag({ property: 'og:title', content: '채용 | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: '최첨단 기술을 넘어 도전을 거부하지 않는 열정적인 20인으로 구성된 팀입니다. 도전에 주저하지 않는다면, 지원하십시오!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/workwithus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/workwithus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/workwithus' });
    
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
